var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"third-pager"},[_c('div',{staticClass:"third"},[_c('iframe',{attrs:{"src":_vm.params.doc,"width":"100%","height":"600px","frameborder":"0"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }